
import { debounce } from '~/mixins/helpers';

export default {
  name: 'BaseScrollHorizontal',
  data() {
    return {
      beforeElement: false,
      afterElement: false,
      innerWidth: 0,
    };
  },
  mounted() {
    this.initialData();
    if (window.innerWidth !== this.innerWidth) {
      window.addEventListener('resize', this.onScroll);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onScroll);
  },
  methods: {
    /** Display the before and after elements according to the scroll position */
    initialData() {
      const content = this.$refs?.content;
      if (!content) {
        return;
      }
      this.beforeElement = content.scrollLeft > 0;
      this.afterElement = Math.round(content.scrollLeft + content.offsetWidth + 3) < Math.round(content.scrollWidth);
    },
    onScroll: debounce(function scrollDebounce() {
      this.initialData();
      this.innerWidth = window.innerWidth;
    }, 100),
  },
};
